__turbopack_context__.v({
  "main": "landing-shell-module-scss-module__sAsLwW__main",
  "root": "landing-shell-module-scss-module__sAsLwW__root",
});
